import { createSelector } from "@reduxjs/toolkit";
const getState = (state) => state.state;
const getIdentity = (state) => state.identity;
const getEndpoint = (state) => state.endpoint;
const getWasPreviouslyConnectedToMqtt = (state) => state.wasPreviouslyConnectedToMqtt;
const getIceServers = (state) => state.iceServers;
const getBrowser = (state) => state.browser;
const getStatsList = (state) => state.keepStats;
export const state = createSelector(getState, (value) => value);
export const identity = createSelector(getIdentity, (value) => value);
export const endpoint = createSelector(getEndpoint, (value) => value);
export const wasPreviouslyConnectedToMqtt = createSelector(getWasPreviouslyConnectedToMqtt, (value) => value);
export const iceServers = createSelector(getIceServers, (value) => value);
export const browser = createSelector(getBrowser, (value) => value);
export const stats = createSelector(getStatsList, (value) => value);
